import { put } from "../../common/api/apiShared";
import { ApprovalOfQualityProjectReportViewModel } from "./ApprovalOfQualityProjectReport.types.ts";
import { useOptimisticUpdate } from "../../common/hooks/useOptimisticUpdate.ts";
import { ApprovalOfQualityProjectReportProps } from "./ApprovalOfQualityProjectReport.tsx";
import { useParams } from "react-router";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useApprovalOfQualityProjectReport(props: ApprovalOfQualityProjectReportProps) {
    const optimisticUpdate = useOptimisticUpdate();

    const { id } = useParams<{ id: string }>();
    const processingActivityId = id === undefined ? props.processingActivityId! : id;

    const url = `/approval-of-quality-project-report/${processingActivityId}`;
    const { isLoading, data, refetch } = useDotLegalQuery<ApprovalOfQualityProjectReportViewModel>(url);

    const reportUpdater = {
        onApprovedEmployeesChange: (value: string) => {
            let temp = { ...data! };
            temp.approvedEmployees = value;
            onReportChange(temp);
        },
        onSignaturesChange: (value: string) => {
            let temp = { ...data! };
            temp.signatures = value;
            onReportChange(temp);
        },
        onApprovalDateChange: (date: Date | null) => {
            let temp = { ...data! };
            temp.approvalDate = date;
            onReportChange(temp);
        },
        onProjectEndDateChange: (date: Date | null) => {
            let temp = { ...data! };
            temp.projectEndDate = date;
            onReportChange(temp);
        },
        onFromJournalPeriodChange: (date: Date | null) => {
            let temp = { ...data! };
            temp.fromJournalPeriod = date;
            onReportChange(temp);
        },
        onToJournalPeriodChange: (date: Date | null) => {
            let temp = { ...data! };
            temp.toJournalPeriod = date;
            onReportChange(temp);
        },
        onDataRetrievedFromDepartmentsChange: (value: string) => {
            let temp = { ...data! };
            temp.dataProvidingDepartments = value;
            onReportChange(temp);
        },
        onJournalInformationGatheredChange: (value: string) => {
            let temp = { ...data! };
            temp.journalDataRetrieved = value;
            onReportChange(temp);
        },
        onDepartmentManagementApprovalChange: (approved: boolean) => {
            let temp = { ...data! };
            temp.departmentManagementHasSetProjectForApproval = approved;
            onReportChange(temp);
        },
        onResponsibleChange: (value: string) => {
            let temp = { ...data! };
            temp.primaryResponsible = value;
            onReportChange(temp);
        },
        onContactPersonChange: (value: string) => {
            let temp = { ...data! };
            temp.contact = value;
            onReportChange(temp);
        },
        onNoteChange: (value: string) => {
            let temp = { ...data! };
            temp.note = value;
            onReportChange(temp);
        },
    };

    async function onReportChange(report: ApprovalOfQualityProjectReportViewModel) {
        await optimisticUpdate.putOnQueueAndSetQueryDataWithNoResponse(report, url, updateControlProcedure, report);
    }

    async function updateControlProcedure(saveModel: ApprovalOfQualityProjectReportViewModel) {
        await put(url, saveModel);
    }

    return {
        isLoading,
        data,
        reportUpdater,
    };
}
